import { RefObject, useEffect } from 'react';

const useOnClickOutside = <TElement extends HTMLDivElement = HTMLDivElement>(
  ref: RefObject<TElement>,
  handler: (e: Event) => void
) => {
  useEffect(() => {
    const listener = (event: Event) => {
      if (!ref?.current || ref.current.contains(event?.target as Node)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [handler, ref]);
};

export default useOnClickOutside;
